export const getTranslatedPrayerNames = (
    prayer_names: any[],
    activeLanguage: string,
    hijralocales: any
  ) => {
    return ["Fajr", "Dhuhr", "Asr", "Maghrib", "Isha", "Midnight"].map((prayer) => {
      const translation = prayer_names.filter(
        (p) => p.original_text === prayer && p.language_code === activeLanguage
      );
      return translation.length > 0 && hijralocales.customLan
        ? translation[0].translated_text
        : prayer;
    });
  };
  
  export const getSubHeaders = (
    timetable_prayer: any[],
    activeLanguage: string,
    hijralocales: any,
    monthMethod: string
  ) => {
    return [
      "Date",
      monthMethod === "13" ? "Suhoor End" : "Fajr Begins",
      "Fajr Iqamah",
      "Sunrise",
      "Dhuhr Begins",
      "Dhuhr Iqamah",
      "Asr Begins",
      "Asr Iqamah",
      monthMethod === "13" ? "Iftar Start" : "Maghrib Begins",
      "Maghrib Iqamah",
      "Isha Begins",
      "Isha Iqamah",
      "Begins"
    ].map((prayer) => {
      const translation = timetable_prayer.find(
        (p) => p.original_text === prayer && p.language_code === activeLanguage
      );
      return translation && hijralocales.customLan
        ? translation.translated_text
        : prayer.replace(/^(Fajr|Dhuhr|Asr|Maghrib|Isha|Midnight)\s/, '');
    });
  };